import styled from 'styled-components';

export const Table = styled.table({
  tableLayout: 'fixed',
  borderCollapse: 'collapse',
  width: '100%',
  borderStyle: 'hidden',

  td: {
    textAlign: 'center',
  },
});
